import { render, staticRenderFns } from "./addAttribute.vue?vue&type=template&id=3f345638&scoped=true"
import script from "./addAttribute.vue?vue&type=script&lang=js"
export * from "./addAttribute.vue?vue&type=script&lang=js"
import style0 from "./addAttribute.vue?vue&type=style&index=0&id=3f345638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f345638",
  null
  
)

export default component.exports